import { getPlaceholderImage } from './placeholder';
// Dummy-Daten für das Senator Watchface basierend auf der PHP-Vorlage
export const mockWatchfaces = [
    {
        id: 14,
        name: "Senator",
        description: "Ein elegantes und funktionsreiches Watchface mit erweiterten Anzeigen für Gezeiten, Wetter und mehr. Perfekt für Outdoor-Aktivitäten und täglichen Gebrauch.",
        coverImage: getPlaceholderImage('Senator'),
        price: 4.0,
        currency: "€",
        storeLink: "https://apps.garmin.com/de-DE/apps/senator",
        code: "SENATOR_2024",
        paddleProductId: "prod_senator_001",
        paddlePriceId: "price_senator_001",
        active: true,
        weblink: "senator",
        images: [
            getPlaceholderImage('Theme 1', 200, 200),
            getPlaceholderImage('Theme 2', 200, 200),
            getPlaceholderImage('Theme 3', 200, 200),
            getPlaceholderImage('Theme 4', 200, 200),
            getPlaceholderImage('Theme 5', 200, 200),
            getPlaceholderImage('Theme 6', 200, 200)
        ],
        colorThemes: [
            {
                id: 1,
                productId: 14,
                name: "1.0.0 Design",
                themeString: "BBAATTABKABBKKKBKKKKKKKKKKKABBB",
                image: getPlaceholderImage('Theme 1', 200, 200),
                description: "Klassisches Design mit blauen und weißen Akzenten",
                sortOrder: 1
            },
            {
                id: 2,
                productId: 14,
                name: "Blue Orange",
                themeString: "EBEAVUABKAEEEEKBKEKEKEKEEKKABAB",
                image: getPlaceholderImage('Theme 2', 200, 200),
                description: "Dynamisches Design mit blauen und orangen Farben",
                sortOrder: 2
            },
            {
                id: 3,
                productId: 14,
                name: "Red Orange Digit",
                themeString: "MMMA^WKBMTBBKMMBMMMMMMMMMMMUBAB",
                image: getPlaceholderImage('Theme 3', 200, 200),
                description: "Kontrastreiches Design mit roten und orangen Ziffern",
                sortOrder: 3
            },
            {
                id: 4,
                productId: 14,
                name: "Green Orange",
                themeString: "BBAAYYABG`BBGGGBGGGGGGGGKKFAGBB",
                image: getPlaceholderImage('Theme 4', 200, 200),
                description: "Natürliches Design mit grünen und orangen Tönen",
                sortOrder: 4
            },
            {
                id: 5,
                productId: 14,
                name: "Red Analogue",
                themeString: "BBAATTABBABBBBPBBBBBBBBBBBBTMBB",
                image: getPlaceholderImage('Theme 5', 200, 200),
                description: "Elegantes analoges Design mit roten Akzenten",
                sortOrder: 5
            },
            {
                id: 6,
                productId: 14,
                name: "Aquamarine / Sand / Slate Analogue",
                themeString: "BBAATTABFAFFFFPBFIIFFCCFCFITFBB",
                image: getPlaceholderImage('Theme 6', 200, 200),
                description: "Beruhigendes Design mit aquamarin und sandfarbenen Tönen",
                sortOrder: 6
            }
        ],
        features: [
            "🌊 Gezeiten-Informationen mit automatischen Updates",
            "🌤️ Wetterdaten von OpenWeatherMap und Yr",
            "🎨 6 vordefinierte Farbthemes + unbegrenzte Anpassungen",
            "📍 GPS-basierte Standortbestimmung",
            "🌅 Automatisches Theme-Switching bei Sonnenuntergang",
            "🔋 Energiesparmodus mit eigenem Theme",
            "⏰ 12h/24h Zeitformat",
            "🌡️ Temperatur in °C/°F",
            "📏 Entfernungen in km/miles",
            "💓 Herzfrequenz-Anzeige",
            "📊 Aktivitätsdaten",
            "🔒 Pro-Features nach 5-Tage-Test"
        ],
        requirements: [
            "Garmin Connect IQ kompatible Uhr",
            "GPS-Fix für Gezeiten- und Wetterdaten",
            "Internetverbindung für Datenupdates",
            "Garmin Connect App"
        ]
    }
];
export const mockFAQs = [
    {
        id: "gps_fix",
        question: "faq.questions.gpsFix.question",
        answer: "faq.questions.gpsFix.answer",
        category: "GPS"
    },
    {
        id: "userdata",
        question: "faq.questions.userData.question",
        answer: "faq.questions.userData.answer",
        category: "Datenschutz"
    },
    {
        id: "permissions",
        question: "faq.questions.permissions.question",
        answer: "faq.questions.permissions.answer",
        category: "Berechtigungen"
    },
    {
        id: "pro_features",
        question: "faq.questions.proFeatures.question",
        answer: "faq.questions.proFeatures.answer",
        category: "Pro Features"
    },
    {
        id: "temperature_units",
        question: "faq.questions.temperatureUnits.question",
        answer: "faq.questions.temperatureUnits.answer",
        category: "Einstellungen"
    },
    {
        id: "time_format",
        question: "faq.questions.timeFormat.question",
        answer: "faq.questions.timeFormat.answer",
        category: "Einstellungen"
    },
    {
        id: "distance_units",
        question: "faq.questions.distanceUnits.question",
        answer: "faq.questions.distanceUnits.answer",
        category: "Einstellungen"
    }
];
